import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import axios from "axios";

import { API } from "../utils/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error("Error de autenticación: No se encontró el ID de sesión");
          navigate("/login");
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data via our backend
        const response = await axios.post(`${API}/auth/google/callback`, {
          session_id: sessionId
        });

        const { token, user } = response.data;

        // Store token and user
        localStorage.setItem("plazafy_token", token);
        localStorage.setItem("plazafy_user", JSON.stringify(user));
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        setToken(token);
        setUser(user);

        toast.success(`¡Bienvenido, ${user.full_name || user.name || user.username || ""}!`);
        
        // Redirect to dashboard
        if (user?.role === "admin") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        const message = error.response?.data?.detail || "Error al procesar la autenticación";
        toast.error(message);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [location, navigate, setUser, setToken]);

  return (
    <div className="min-h-screen bg-[#1a1625] flex flex-col items-center justify-center">
      <Loader2 className="w-12 h-12 text-violet-500 animate-spin mb-4" />
      <p className="text-white text-lg">Procesando autenticación...</p>
      <p className="text-gray-400 text-sm mt-2">Por favor, espera un momento</p>
    </div>
  );
}
